module.exports = __webpack_public_path__ + "img/gw.396d6bbb.svg";